module.exports = __webpack_public_path__ + "static/media/music.60bfed51.svg";